"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialValues = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var Box_1 = __importDefault(require("../../Box"));
var Link_1 = __importDefault(require("../../Link"));
var InputField_1 = __importDefault(require("../Fields/InputField"));
var ConfirmPasswordField_1 = __importDefault(require("./ConfirmPasswordField"));
var EmailField_1 = __importDefault(require("./EmailField"));
var NewPasswordField_1 = __importDefault(require("./NewPasswordField"));
var PasswordField_1 = __importDefault(require("./PasswordField"));
var VerifyEmailButton_1 = __importDefault(require("./VerifyEmailButton"));
var validation_1 = require("../../utils/validation");
var Text_1 = __importDefault(require("../../Text"));
var CheckBoxField_1 = __importDefault(require("../Fields/CheckBoxField"));
var ButtonWithErrorBox_1 = __importDefault(require("../ButtonWithErrorBox"));
var IFrameModal_1 = __importDefault(require("../../Modal/presets/IFrameModal"));
exports.initialValues = {
    email: '',
    password: '',
    newPassword: '',
    confirmPassword: '',
    verificationCode: '',
    registerAgreement: false
};
function AuthForm(props) {
    var _this = this;
    var linkModal = props.linkModal, userExist = props.userExist, privacyPolicyLink = props.privacyPolicyLink, termsLink = props.termsLink, forgotPasswordLink = props.forgotPasswordLink, onValidEmailChange = props.onValidEmailChange, onVerifyClick = props.onVerifyClick;
    var handleEmailChange = function (event) { return __awaiter(_this, void 0, void 0, function () {
        var email, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    email = event.target.value;
                    if (!(0, validation_1.isEmail)(email)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (onValidEmailChange === null || onValidEmailChange === void 0 ? void 0 : onValidEmailChange(email))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('onValidEmailChange failed', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(EmailField_1.default, { autoCorrect: "off", autoCapitalize: "off", spellCheck: "false", onChange: handleEmailChange, bottomContent: react_1.default.createElement(LoginRegisterSwitch, { userExist: userExist, loginContent: null, registerContent: react_1.default.createElement(Hint, null, "Please register a new account") }), required: true }),
        react_1.default.createElement(LoginRegisterSwitch, { userExist: userExist, loginContent: react_1.default.createElement(LoginForm, { forgotPasswordLink: forgotPasswordLink }), registerContent: react_1.default.createElement(RegisterForm, { linkModal: linkModal, privacyPolicyLink: privacyPolicyLink, termsLink: termsLink, onVerifyClick: onVerifyClick }) })));
}
exports.default = AuthForm;
function LoginForm(props) {
    var forgotPasswordLink = props.forgotPasswordLink;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PasswordField_1.default, { required: true }),
        react_1.default.createElement(ButtonWithErrorBox_1.default, { name: 'login', fullWidth: true, variant: 'dark' }, "Login"),
        react_1.default.createElement(Link_1.default, { href: forgotPasswordLink, mt: '18px', fontSize: '12px', textDecoration: 'underline' }, "Forgot Password")));
}
function RegisterForm(props) {
    var onVerifyClick = props.onVerifyClick, privacyPolicyLink = props.privacyPolicyLink, termsLink = props.termsLink, linkModal = props.linkModal;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(NewPasswordField_1.default, { label: 'Password', required: true }),
        react_1.default.createElement(PasswordRules, null),
        react_1.default.createElement(ConfirmPasswordField_1.default, { required: true }),
        react_1.default.createElement(VerificationContainer, null,
            react_1.default.createElement(Box_1.default, { flex: '2' },
                react_1.default.createElement(InputField_1.default, { name: 'verificationCode', label: 'Verification Code', maxLength: 6, required: true })),
            react_1.default.createElement(Box_1.default, { flex: '1', mb: '28px' },
                react_1.default.createElement(VerifyEmailButton_1.default, { p: '0px', height: '42px', variant: 'outlineDark', onClick: onVerifyClick }))),
        react_1.default.createElement(AgreementCheckBox, { privacyPolicyLink: privacyPolicyLink, termsLink: termsLink, linkModal: linkModal }),
        react_1.default.createElement(ButtonWithErrorBox_1.default, { name: 'register', fullWidth: true, variant: 'dark' }, "Register")));
}
function AgreementCheckBox(props) {
    var _a = (0, react_1.useState)(false), openOrderAgreement = _a[0], setOpenOrderAgreement = _a[1];
    var _b = (0, react_1.useState)(false), openTermsOfUse = _b[0], setOpenTermsOfUse = _b[1];
    return (react_1.default.createElement(Box_1.default, { display: 'flex', my: '38px' },
        react_1.default.createElement(CheckBoxField_1.default, { name: 'registerAgreement', required: true, label: react_1.default.createElement(Text_1.default, { fontSize: '14px', lineHeight: '22px' }, "I have read and hereby agree to the terms and conditions set forth in the Faraday Future ",
                react_1.default.createElement(Link_1.default, { textDecoration: 'underline', href: props.linkModal ? undefined : props.privacyPolicyLink, onClick: props.linkModal ? function () { return setOpenOrderAgreement(true); } : undefined }, "Privacy Policy"), " and ",
                react_1.default.createElement(Link_1.default, { textDecoration: 'underline', href: props.linkModal ? undefined : props.termsLink, onClick: props.linkModal ? function () { return setOpenTermsOfUse(true); } : undefined }, "Terms of Use")) }),
        props.linkModal && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(IFrameModal_1.default, { styleProps: { width: '85vw', height: '85vh' }, open: openTermsOfUse, link: props.termsLink, onClose: function () { return setOpenTermsOfUse(false); }, closeIcon: true }),
            react_1.default.createElement(IFrameModal_1.default, { styleProps: { width: '85vw', height: '85vh' }, open: openOrderAgreement, link: props.privacyPolicyLink, onClose: function () { return setOpenOrderAgreement(false); }, closeIcon: true })))));
}
function PasswordRules() {
    return (react_1.default.createElement(Box_1.default, { mb: '24px' },
        react_1.default.createElement(Hint, null, "Password must be at least:"),
        react_1.default.createElement(Hint, null, "\u2022 8 characters"),
        react_1.default.createElement(Hint, null, "\u2022 no spaces")));
}
function LoginRegisterSwitch(props) {
    var userExist = props.userExist, loginContent = props.loginContent, registerContent = props.registerContent;
    return (react_1.default.createElement(react_1.default.Fragment, null, typeof userExist !== 'boolean'
        ? null // render nothing
        : userExist
            ?
                loginContent
            :
                registerContent));
}
var VerificationContainer = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
    gap: '8px',
    alignItems: 'flex-end'
});
var Hint = (0, styled_1.default)(Text_1.default)({
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.5)'
});
